import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleBasedAccessPatterns = ({ data }) => {
  const getRoleIcon = (roleName) => {
    const lowerRole = roleName?.toLowerCase();
    if (lowerRole?.includes('admin')) return 'Shield';
    if (lowerRole?.includes('manager')) return 'Users';
    if (lowerRole?.includes('hr')) return 'UserCheck';
    if (lowerRole?.includes('finance')) return 'DollarSign';
    if (lowerRole?.includes('compliance')) return 'FileCheck';
    return 'User';
  };

  const getAccessLevel = (totalAccess) => {
    if (totalAccess >= 100) return { label: 'Very High', color: 'text-success' };
    if (totalAccess >= 50) return { label: 'High', color: 'text-accent' };
    if (totalAccess >= 20) return { label: 'Medium', color: 'text-warning' };
    return { label: 'Low', color: 'text-muted-foreground' };
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="mb-6">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1">
          Role-Based Access Patterns
        </h3>
        <p className="caption text-xs md:text-sm text-muted-foreground">
          Most-accessed modules by user role
        </p>
      </div>

      <div className="space-y-4">
        {data?.slice(0, 6)?.map((role, index) => {
          const accessLevel = getAccessLevel(role?.totalAccess);
          return (
            <div 
              key={index}
              className="p-4 bg-muted/30 rounded-md border border-border hover:bg-muted/50 transition-smooth"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <div className="bg-primary/10 text-primary p-2 rounded-md">
                    <Icon name={getRoleIcon(role?.roleName)} size={18} color="currentColor" />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <p className="font-heading text-sm font-medium text-foreground">
                      {role?.roleName}
                    </p>
                    <span className={`caption text-xs font-medium ${accessLevel?.color}`}>
                      {accessLevel?.label}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-xs">
                    <div className="flex items-center gap-1">
                      <Icon name="MousePointer" size={12} color="var(--color-muted-foreground)" />
                      <span className="data-text text-muted-foreground">
                        {role?.totalAccess} accesses
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Layout" size={12} color="var(--color-muted-foreground)" />
                      <span className="data-text text-muted-foreground">
                        {role?.moduleCount} modules
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 pt-2 border-t border-border/50">
                    <div className="flex items-center gap-2">
                      <span className="caption text-xs text-muted-foreground">Top Module:</span>
                      <span className="data-text text-xs font-medium text-foreground capitalize">
                        {role?.topModule?.replace(/-/g, ' ')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {data?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Users" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3 opacity-50" />
          <p className="caption text-sm text-muted-foreground">No role access data available</p>
        </div>
      )}
    </div>
  );
};

export default RoleBasedAccessPatterns;